/**
 * @generated SignedSource<<31c03e0e0b6ef7847faaae3aa62792ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionText_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collapsible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collapsedHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "columnsRatio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "columnsOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sidebar",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContainerWithSidebar_sidebar"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionText",
  "abstractKey": null
};

node.hash = "cc7d4758a43868bed2484e772f5d55cc";

module.exports = node;
